import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

import mailupApi from '../api/mailup'
import submitFormikWithValidationToast from '../utils/submitFormikWithValidationToast'
import validators from '../utils/validators'
import defaultValues from '../utils/defaultValues'
import FormMailUp from '../components/form/FormMailUp'
import BottoniScheda from '../components/scheda/BottoniScheda'

function MailUp(props) {
  const [errore, setErrore] = useState(null)
  const [successo, setSuccesso] = useState(false)
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    validationSchema: validators.mailup,
    initialValues: defaultValues.mailup,
    onSubmit: async (values) => {
      setLoading(true)
      const results = await mailupApi.saveCredentials({
        username: values.username,
        pwd: values.pwd,
      })
      if (!results.ok) {
        setErrore(results.data)
        return setLoading(false)
      }
      setLoading(false)
      setErrore(null)
      setSuccesso(true)
    },
  })

  useEffect(() => {
    const caricaCredenziali = async () => {
      const results = await mailupApi.getCredentials()
      if (!results.ok) {
        setErrore(results.data)
        return
      }
      formik.setValues({
        username: results.data?.username || '',
        pwd: results.data?.pwd || '',
      })
    }
    caricaCredenziali()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const confermaFormikValidato = () => submitFormikWithValidationToast(formik, setErrore)

  const chiudiAlert = (event, reason) => {
    if (reason === 'clickaway') return
    setErrore()
  }

  const chiudiSuccesso = (event, reason) => {
    if (reason === 'clickaway') return
    setSuccesso(false)
  }

  return (
    <React.Fragment>
      <Box
        sx={{
          width: '70%',
          backgroundColor: 'white',
          borderRadius: '10px',
          border: '1px solid #dcdcdc',
          p: 2,
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography sx={{ fontSize: 24, fontWeight: 'bold' }}>Credenziali MailUp</Typography>
        <Typography sx={{ fontSize: 14, color: '#666', marginTop: 1 }}>
          Username e password usati per l'autenticazione al servizio newsletter MailUp. I valori sono salvati crittati sul
          database.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '70%',
          backgroundColor: 'white',
          borderRadius: '10px',
          border: '1px solid #dcdcdc',
          p: 2,
          marginTop: '30px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <FormMailUp
          values={formik.values}
          errors={formik.errors}
          touched={formik.touched}
          setFieldValue={formik.setFieldValue}
          handleChange={(value) => formik.handleChange(value)}
        ></FormMailUp>
        <BottoniScheda
          loading={loading}
          conferma={confermaFormikValidato}
          annulla={() => formik.resetForm()}
        ></BottoniScheda>
      </Box>

      <Snackbar
        open={errore?.length > 0}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
          {errore}
        </Alert>
      </Snackbar>

      <Snackbar
        open={successo}
        onClose={chiudiSuccesso}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ top: 70 }}
      >
        <Alert onClose={chiudiSuccesso} variant="filled" severity="success" sx={{ width: '100%' }}>
          Credenziali MailUp salvate correttamente.
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}

export default MailUp
